<template>
    <div>
        <b-form>
            <div class="row">
                <div class="col-12">
                    <card-title-component :title="$t('pets.addPet.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <b-form-group id="name-form-group"
                                              class="o-label"
                                              :label="$t('pets.pet.name')"
                                              label-for="name-input">
                                    <b-form-input id="name-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localName"
                                                  required
                                                  :placeholder="$t('pets.pet.name')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col">
                                <b-form-group id="species-form-group"
                                              class="o-label"
                                              :label="$t('pets.pet.species')"
                                              label-for="species-input">
                                    <b-form-input id="species-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localSpecies"
                                                  required
                                                  :placeholder="$t('pets.pet.species')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="birthdate-form-group"
                                              class="o-label"
                                              :label="$t('pets.pet.birthdate')"
                                              label-for="birthdate-input">
                                    <datepicker v-model="localBirthdate" id="birthdate-input" class="o-form" :format="'dd.MM.yyyy'" :language="this.getLanguage()"></datepicker>
                                </b-form-group>
                            </div>
                            <div class="col">
                                <b-form-group id="transponder-id-form-group"
                                              class="o-label"
                                              :label="$t('pets.pet.transponderId')"
                                              label-for="transponder-id-input">
                                    <b-form-input id="transponder-id-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localTransponderId"
                                                  required
                                                  :placeholder="$t('pets.pet.transponderId')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="veterinarian-form-group"
                                              class="o-label"
                                              :label="$t('pets.pet.veterinarian')"
                                              label-for="veterinarian-input">
                                    <b-form-input id="veterinarian-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localVeterinarian"
                                                  required
                                                  :placeholder="$t('pets.pet.addressPlaceholder')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="custody-after-death-form-group"
                                              class="o-label"
                                              :label="$t('pets.pet.custody')"
                                              label-for="custody-after-death-input">
                                    <b-form-input id="custody-after-death-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localCustodyAfterDeath"
                                                  required
                                                  :placeholder="$t('pets.pet.addressPlaceholder')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="notes-form-group"
                                              class="o-label"
                                              :label="$t('pets.pet.notes')"
                                              label-for="notes-input">
                                    <b-form-textarea id="notes-input"
                                                     class="o-form"
                                                     type="text"
                                                     v-model="localNotes"
                                                     :rows="5"
                                                     :max-rows="10"
                                                     :placeholder="$t('pets.pet.notes')">
                                    </b-form-textarea>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 button-div">
                    <b-button class="cancel-button o-button" v-on:click="cancel">
                        {{$t('pets.addPet.cancelButton')}}
                    </b-button>
                    <b-button class="save-button o-button" v-on:click="addPet">
                        {{$t('pets.saveButton')}}
                    </b-button>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {
        PETS_NAMESPACE,
        PETS_ACTION_CREATE_PET
    } from '../../store/modules/pets-types'
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import Datepicker from 'vuejs-datepicker'
    import {de, en} from 'vuejs-datepicker/dist/locale'

    export default {
        name: 'AddPet',
        components: {
            'card-title-component': CardTitleComponent,
            'datepicker': Datepicker
        },
        data () {
            return {
                localName: '',
                localSpecies: '',
                localTransponderId: '',
                localBirthdate: '',
                localVeterinarian: '',
                localCustodyAfterDeath: '',
                localNotes: '',
                modal_state: 'invited'
            }
        },
        methods: {
            ...mapActions(PETS_NAMESPACE, {
                createPet: PETS_ACTION_CREATE_PET
            }),
            addPet () {
                this.createPet({
                    name: this.localName,
                    species: this.localSpecies,
                    transponderId: this.localTransponderId,
                    birthdate: this.localBirthdate,
                    veterinarian: this.localVeterinarian,
                    custodyAfterDeath: this.localCustodyAfterDeath,
                    notes: this.localNotes
                })
                this.localName = ''
                this.localSpecies = ''
                this.localTransponderId = ''
                this.localBirthdate = ''
                this.localVeterinarian = ''
                this.localCustodyAfterDeath = ''
                this.localNotes = ''
                this.$root.$emit('bv::hide::modal', 'add-pet-modal')
            },
            cancel () {
                this.$root.$emit('bv::hide::modal', 'add-pet-modal')
            },
            getLanguage () {
                if (this.$i18n.locale === 'en') {
                    return en
                } else {
                    return de
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/pets/AddPetComponent.vue